import React from 'react';
import Link from 'next/link';

const usefulLinks = ['Home', 'About Us', 'Careers', 'Blog', 'Press', 'Lead Freshness', 'Big Basket for Business'];
const categories = ['Vegetables & Fruits', 'Dairy & Breakfast', 'Munchies', 'Cold Drinks & Juices', 'Instant & Frozen Food', 'Tea, Coffee & Health Drinks', 'Bakery & Biscuits', 'Sweet Tooth', 'Atta, Rice & Dal', 'Sauces & Spreads'];
const helpLinks = ['FAQs', 'Contact Us', 'Privacy Policy', 'Terms & Conditions', 'Refund Policy', 'Return Policy', 'Pricing & Delivery Policy', 'Cookie Policy'];
const policyLinks = ['Grievance Redressal', 'Disclaimer', 'Pickup Points', 'Cancellation Policy', 'Responsible Disclosure', 'Sitemap'];
const cities = ['Agra', 'Ahmedabad', 'Aligarh', 'Allahabad', 'Bengaluru', 'Bhopal', 'Chandigarh', 'Chennai', 'Delhi', 'Faridabad', 'Gurugram', 'Guwahati', 'Hyderabad', 'Jaipur', 'Kanpur', 'Kolkata', 'Lucknow', 'Mumbai', 'Noida', 'Patna', 'Pune', 'Surat', 'Vadodara', 'Varanasi', 'Visakhapatnam'];

export default function Footer() {
  return (
    <footer className="bg-[#1c1c1c] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-12 pb-8">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pb-8 border-b border-white/10">
          <div className="flex flex-col gap-2">
            <Link href="/" className="flex items-center gap-2 group bg-gray-200 w-fit p-2 rounded-md">
              <img
                alt="Big Basket Logo"
                className="h-8 md:h-10 transition-transform duration-200 group-hover:scale-105"
                src="https://boxbasket.vercel.app/assets/logo-0Uqv8tyd.png" />
              
            </Link>
            <p className="text-sm text-gray-400 max-w-xs leading-relaxed">
              India&apos;s fastest online shopping platform. Groceries &amp; more delivered in minutes.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-sm font-semibold text-gray-300">Download our app</p>
            <div className="flex gap-3">
              <a href="#" className="hover:opacity-80 transition-opacity active:scale-95">
                <img
                  alt="Get it on Google Play"
                  className="h-10 rounded-md"
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" />
                
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity active:scale-95">
                <img
                  alt="Download on the App Store"
                  className="h-10 rounded-md"
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" />
                
              </a>
            </div>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-10 border-b border-white/10">
          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Useful Links</h4>
            <ul className="space-y-2.5">
              {usefulLinks?.map((link) =>
              <li key={link}><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">{link}</a></li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Categories</h4>
            <ul className="space-y-2.5">
              {categories?.map((cat) =>
              <li key={cat}><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">{cat}</a></li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Help &amp; Support</h4>
            <ul className="space-y-2.5">
              {helpLinks?.map((link) =>
              <li key={link}><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">{link}</a></li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-white mb-4 uppercase tracking-wider">Our Policies</h4>
            <ul className="space-y-2.5">
              {policyLinks?.map((link) =>
              <li key={link}><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">{link}</a></li>
              )}
            </ul>
          </div>
        </div>

        {/* Social */}
        <div className="flex items-center gap-4 py-8 border-b border-white/10">
          <p className="text-sm font-semibold text-gray-400 mr-2">Follow us</p>
          {/* Facebook */}
          <a href="#" className="w-9 h-9 bg-white/10 hover:bg-[#0c831f] rounded-full flex items-center justify-center transition-colors duration-200">
            <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
          </a>
          {/* Twitter/X */}
          <a href="#" className="w-9 h-9 bg-white/10 hover:bg-[#0c831f] rounded-full flex items-center justify-center transition-colors duration-200">
            <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.261 5.636L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
          </a>
          {/* Instagram */}
          <a href="#" className="w-9 h-9 bg-white/10 hover:bg-[#0c831f] rounded-full flex items-center justify-center transition-colors duration-200">
            <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" /></svg>
          </a>
          {/* LinkedIn */}
          <a href="#" className="w-9 h-9 bg-white/10 hover:bg-[#0c831f] rounded-full flex items-center justify-center transition-colors duration-200">
            <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
          </a>
          {/* YouTube */}
          <a href="#" className="w-9 h-9 bg-white/10 hover:bg-[#0c831f] rounded-full flex items-center justify-center transition-colors duration-200">
            <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
          </a>
        </div>

        {/* Delivery Cities */}
        <div className="py-8 border-b border-white/10">
          <p className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-4">We deliver in</p>
          <div className="flex flex-wrap gap-x-3 gap-y-2">
            {cities?.map((city, i) =>
            <span key={city} className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer transition-colors">
                {city}{i < cities?.length - 1 && <span className="ml-3 text-gray-700">|</span>}
              </span>
            )}
          </div>
        </div>

        {/* About */}
        <div className="py-8 border-b border-white/10">
          <p className="text-sm font-bold text-gray-300 uppercase tracking-wider mb-3">About Big Basket</p>
          <p className="text-xs text-gray-500 leading-relaxed max-w-4xl">
            Big Basket is India&apos;s fastest online shopping platform. Get fresh groceries and much more delivered online in minutes. Order thousands of products at just a tap: milk, eggs, bread, cooking oil, ghee, atta, rice, fresh fruits and vegetables, spices, fresh meat, seafood, frozen food, chocolates, chips, biscuits, cold drinks, shampoos, soaps, diapers, electronics, sanitizers, sanitary napkins, health products, and much more from your nearest stores.
          </p>
          <p className="text-xs text-gray-600 leading-relaxed mt-3 max-w-4xl">
            &quot;Big Basket&quot; is owned &amp; managed by &quot;Grofers India Private Limited&quot; and is not related, linked or interconnected in whatsoever manner or nature, to &quot;GROFFR.COM&quot;. By continuing past this page, you agree to our Terms of Service, Cookie Policy, Privacy Policy and Content Policies.
          </p>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="bg-black/40 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-500">&copy; 2025 Grofers India Pvt. Ltd. All Rights Reserved.</p>
          <div className="flex items-center gap-4 text-xs text-gray-600">
            <a href="#" className="hover:text-gray-400 transition-colors">Privacy</a>
            <span>&middot;</span>
            <a href="#" className="hover:text-gray-400 transition-colors">Terms</a>
            <span>&middot;</span>
            <a href="#" className="hover:text-gray-400 transition-colors">Cookies</a>
            <span>&middot;</span>
            <span>Made in India</span>
          </div>
        </div>
      </div>
    </footer>);

}